uniform sampler2D uPositions;
uniform float uSize;
uniform float uPixelRatio;
uniform vec2 uResolution;
uniform float uScroll;
varying vec3 vPos;
varying vec2 vUv;

void main() {
  vec3 pos = texture2D( uPositions, position.xy ).xyz;

  float range = 1.0 / uTotalModels;
  float customSize = uSize;

  vec4 modelPosition = modelMatrix * vec4(pos, 1.0);
  vec4 viewPosition = viewMatrix * modelPosition;
  vec4 projectionPosition = projectionMatrix * viewPosition;

  if (uScroll < range) {
    customSize = mix(7.0, 10.0, uScroll * uTotalModels);
  } else if (uScroll < range * 2.0) {
    customSize = mix(10.0, 8.0, (uScroll - range) * uTotalModels);
  } else if (uScroll < range * 3.0) {
    customSize = mix(8.0, 13.0, (uScroll - range * 2.0) * uTotalModels);
  } else {
    float scroll = max((uScroll - range * 3.0), (uScroll - range * 3.0) * uTotalModels);
    customSize = mix(13.0, 9.0, scroll);
  }

  gl_Position = projectionPosition;
  // Refined point size for crisp stardust particle rendering
  gl_PointSize = customSize * uResolution.y * 0.0010;
  gl_PointSize *= (1.0 / max(abs(viewPosition.z), 0.1));

  vPos = pos;
}
